import React, {useEffect} from 'react';
import {useAppDispatch} from '@/Pages/Common/hooks/useAppDispatch';
import {Infobox} from '@flixbus/honeycomb-react';
import {useAppSelector} from '@/Pages/Common/hooks/useAppSelector';
import ContentLoader from '@/Pages/Common/ContentLoader';
import {fetchCountrySpecificCost} from '../../store/thunks';
import {useCountryCostsQueryParams} from '../../hooks/useCountryCostsQueryParams';
import RegionalCostsDriverCostContent from './RegionalCostsDriverCostContent/RegionalCostsDriverCostContent';

const RegionalCostsDriverCostTab: React.FC = () => {
  const driverCost = useAppSelector(
    ({regionalCosts}) => regionalCosts.driverCost
  );
  const dispatch = useAppDispatch();

  const {countryId, year} = useCountryCostsQueryParams();
  const country =
    useAppSelector(({countries}) =>
      countries.list?.find(({id}) => id === countryId)
    ) ?? null;

  useEffect(() => {
    dispatch(fetchCountrySpecificCost(countryId, year));
  }, [countryId, year, dispatch]);

  if (countryId === null || year === null) {
    return (
      <Infobox appearance="warning">
        <p>
          Select <strong>country</strong> and <strong>calendar year</strong>
        </p>
      </Infobox>
    );
  }

  if (country === null || driverCost === null) return <ContentLoader />;

  return (
    <RegionalCostsDriverCostContent
      country={country}
      year={year}
      driverCost={driverCost}
    />
  );
};

export default React.memo(RegionalCostsDriverCostTab);
